var $e6d75df4b68bd73a$exports = {};
$e6d75df4b68bd73a$exports = {
    "dismiss": `Rejeter`
};


export {$e6d75df4b68bd73a$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
